import axios from "axios";
import { useQuery } from "react-query";
import { END_POINT } from "config/environment";
import { IGeneralProps } from "types";

export const QUERY_KEY_FOR_JOB_APPLICANTS = "suggested-applicants";

const getSuggestedTalents = async (
    props: IGeneralProps
) => {
    const id = props.id;
    const url = `${END_POINT.BASE_URL}/v1/suggested-talents/${id}`;
    const config = {
        headers: {
            Accept: "application/json",
            Authorization: `Bearer ${props.token}`,
        },
    };

    const res = await axios.get(url, config);
    const data = res.data;


    return data;
};

export const useGetSuggestedTalents = ({ id, token }: IGeneralProps) => {
    const queryData = useQuery([QUERY_KEY_FOR_JOB_APPLICANTS, id], () =>
        getSuggestedTalents({
            id,
            token,
        })
    );

    return queryData;
};
